import { Loader } from '@grafikr/components';

/**
 * Auto-load when location.hash matches this node's id.
 * Opt-in via data-sync-hash (uses data-load-target) or data-load-hash="id".
 */
export default Loader(({ node }, load) => {
  const hashId =
    node.dataset.loadHash?.trim() ||
    (node.hasAttribute('data-sync-hash')
      ? (node.dataset.loadTarget?.split(',')[0]?.trim() ?? '')
      : '');

  if (!hashId) {
    return;
  }

  const current = decodeURIComponent(window.location.hash.replace(/^#/, ''));

  if (current === hashId) {
    load();
  }
});
